const DEFAULT_SALT = "dev-no-salt-set";
function readSalt() {
  try {
    const fromProcess = typeof process !== "undefined" ? process.env?.SENTRY_HASH_SALT || "" : "";
    if (fromProcess) return fromProcess;
  } catch {
  }
  try {
    const fromVite = import.meta?.env?.VITE_SENTRY_HASH_SALT || import.meta?.env?.SENTRY_HASH_SALT || "";
    if (fromVite) return fromVite;
  } catch {
  }
  try {
    const g = globalThis;
    const fromGlobal = g?.__SENTRY_HASH_SALT__ || g?.__VITE_SENTRY_HASH_SALT__ || g?.VITE_SENTRY_HASH_SALT || "";
    if (fromGlobal) return String(fromGlobal);
  } catch {
  }
  try {
    console.warn("[sentry.hash] SENTRY_HASH_SALT missing; using placeholder (set SENTRY_HASH_SALT to fix)");
  } catch {
  }
  return DEFAULT_SALT;
}
function toHex(buffer) {
  const bytes = buffer instanceof ArrayBuffer ? new Uint8Array(buffer) : buffer;
  let out = "";
  for (let i = 0; i < bytes.length; i++) {
    const h = bytes[i].toString(16).padStart(2, "0");
    out += h;
  }
  return out;
}
function stableHash(input) {
  const salt = readSalt();
  const data = `${salt}:${input}`;
  const nodeCrypto = typeof process !== "undefined" ? require("node:crypto") : null;
  if (!nodeCrypto) {
    throw new Error("stableHash() is not available in the browser. Use stableHashWeb().");
  }
  return nodeCrypto.createHash("sha256").update(data).digest("hex");
}
async function stableHashWeb(input) {
  const salt = readSalt();
  const data = `${salt}:${input}`;
  const enc = new TextEncoder();
  const subtle = globalThis?.crypto?.subtle;
  if (!subtle) {
    let acc = 0;
    for (let i = 0; i < data.length; i++) acc = acc * 31 + data.charCodeAt(i) >>> 0;
    return acc.toString(16).padStart(8, "0").repeat(8).slice(0, 64);
  }
  const digest = await subtle.digest("SHA-256", enc.encode(data));
  return toHex(digest);
}
export {
  stableHash,
  stableHashWeb
};
